<template>
  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['isAuthenticated', 'getDoctorProfile'])
  },
  async mounted() {
    console.log('=== App mounted - 应用启动 ===')
    
    // 如果用户已登录但医生信息不存在，尝试获取医生信息
    if (this.isAuthenticated && !this.getDoctorProfile) {
      console.log('📡 用户已登录但医生信息缺失，尝试获取医生信息...')
      try {
        const result = await this.fetchDoctorProfile()
        if (result && result.success) {
          console.log('✅ 医生信息获取成功:', result.data)
        } else {
          console.warn('⚠️ 医生信息获取失败:', result?.message)
        }
      } catch (error) {
        console.error('❌ 获取医生信息异常:', error)
      }
    } else if (this.getDoctorProfile) {
      console.log('✅ 医生信息已存在:', this.getDoctorProfile)
    } else {
      console.log('ℹ️ 用户未登录，跳过医生信息获取')
    }
  },
  methods: {
    ...mapActions(['fetchDoctorProfile'])
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style> 